import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './UpgradeOutcome.css';

export const UpgradeSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="upgrade-outcome-container">
            <div className="outcome-card success">
                <div className="outcome-icon">✅</div>
                <h1>{t('application_sent_success', 'Solicitação enviada!')}</h1>
                <p>
                    {t('upgrade_success_desc', 'Seu pedido de verificação foi enviado. Agora o administrador irá analisar seu perfil do Instagram e aprovar seu acesso como artista.')}
                </p>
                <button onClick={() => navigate('/home')} className="outcome-btn">
                    {t('back_to_home', 'Voltar ao Início')}
                </button>
            </div>
        </div>
    );
};

export const UpgradeError = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const message = searchParams.get('message') || t('application_error', 'Ocorreu um erro na solicitação.');

    return (
        <div className="upgrade-outcome-container">
            <div className="outcome-card error">
                <div className="outcome-icon">❌</div>
                <h1>{t('error', 'Ops!')}</h1>
                <p>{message}</p>
                <button onClick={() => navigate('/home')} className="outcome-btn secondary">
                    {t('try_again', 'Tentar Novamente')}
                </button>
            </div>
        </div>
    );
};
